import React, { Component } from "react";

const LIST = [
  "리서치 상",
  "입안 상",
  "요약 상",
  "반박 상",
  "마지막 초점 상",
  "목소리 큰 상",
  "아이컨텍 상",
  "경청 상"
];

export default class Titles extends Component {
  render() {
    return (
      <>
        <div className="row">
          <div className="col-12">상장 목록</div>
        </div>

        <div className="row mt-2 mb-5">
          <div className="col-12">
            {LIST.sort().map((award, idx) => (
              <span
                key={idx}
                className="mx-2 my-1 py-2 px-3 badge badge-pill badge-warning"
              >
                {award}
              </span>
            ))}
          </div>
        </div>
      </>
    );
  }
}
